<template>
  <v-dialog v-model="dialog" width="415" height="250">
    <v-card height="250">
      <v-card-title class="back-556C96 color-white mb-5">
        삭제여부
      </v-card-title>
      <v-card-text class="mb-3  pa-5 text-center">
        <h3 v-text="text" />
      </v-card-text>
      <v-card-actions class="justify-center ">
        <v-btn
          color="#718FC7"
          class="color-white"
          @click="dialog = false"
          rounded
          width="140"
          height="38"
        >
          취소
        </v-btn>
        <v-btn
          color="#3F557D"
          class="color-white"
          rounded
          width="140"
          height="38"
          @click="deleteCompanyOrUser"
        >
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserApi from "../api/UserService";
import CompanyApi from "../api/CompanyService";
export default {
  created() {
    this.$bus.$on("confirmOn", (status, value) => {
      if (status == "company") {
        this.text = "업체를 삭제하시겠습니까?";
        this.companyId = value;
      } else if (status == "user") {
        this.text = "유저를 삭제하시겠습니까?";
        this.userId = value;
      }
      this.dialog = true;
    });
  },
  data: function() {
    return {
      dialog: false,
      text: "",
      userId: "",
      companyId: "",
    };
  },
  watch: {
    dialog(val) {
      if (!val) this.reset();
    },
  },
  methods: {
    reset() {
      this.text = "";
      this.userId = "";
      this.companyId = "";
    },
    async deleteCompanyOrUser() {
      let text = "";
      let res = "";
      let data;
      let status = "";
      if (this.companyId) {
        data = { companyId: this.companyId };
        res = await CompanyApi.companyDelete(data);
        text = "이미 삭제되었거나 사용중인 회사입니다.";
        status = "constructionNavigationDuplicated";
      } else {
        data = { userId: this.userId };
        res = await UserApi.userDelete(data);
        text = "이미 삭제되었거나 사용중인 아이디입니다.";
        status = "deleteOnUser";
      }
      if (res.data.success == "ok") {
        text = "삭제가 완료되었습니다.";
        this.$bus.$emit(status, true);
      }
      this.dialog = false;
      this.$bus.$emit("dialog", text);
    },
  },
};
</script>
